//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseClient {
  // eslint-disable-next-line no-undef
  public async transformOptions(options: RequestInit): Promise<RequestInit> {
    const token = localStorage.getItem('token') ?? '';

    const headerData = token
      ? {
          ...options.headers,
          Authorization: 'Bearer ' + token,
          TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }
      : {
          ...options.headers,
        };

    return Object.assign({}, options, {
      headers: headerData,
    });
  }
}

export class AgentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    get(): Promise<AgentDTO[]> {
        let url_ = this.baseUrl + "/api/Agent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AgentDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentDTO[]>(null as any);
    }

    insert(dto: AgentDTO): Promise<AgentDTO> {
        let url_ = this.baseUrl + "/api/Agent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<AgentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentDTO>(null as any);
    }

    update(dto: AgentDTO): Promise<AgentDTO> {
        let url_ = this.baseUrl + "/api/Agent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<AgentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentDTO>(null as any);
    }

    delete(dto: AgentDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/Agent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeviceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    upsert(deviceRegistrationDTO: DeviceRegistrationDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/Device/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceRegistrationDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    remove(deviceRegistrationDTO: DeviceRegistrationDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceRegistrationDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MachineClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getForCurrentUser(): Promise<MachineDTO[]> {
        let url_ = this.baseUrl + "/api/Machine/GetForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForCurrentUser(_response);
        });
    }

    protected processGetForCurrentUser(response: Response): Promise<MachineDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MachineDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineDTO[]>(null as any);
    }

    addNewMachine(dto: AddMachineDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/Machine/AddNewMachine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddNewMachine(_response);
        });
    }

    protected processAddNewMachine(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @deprecated
     */
    getForCurrentUserApp(): Promise<MachineAppDTO[]> {
        let url_ = this.baseUrl + "/api/Machine/GetForCurrentUserApp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForCurrentUserApp(_response);
        });
    }

    protected processGetForCurrentUserApp(response: Response): Promise<MachineAppDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MachineAppDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineAppDTO[]>(null as any);
    }

    getForCurrentUserAppV2(): Promise<MachineDTO[]> {
        let url_ = this.baseUrl + "/api/Machine/GetForCurrentUserAppV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForCurrentUserAppV2(_response);
        });
    }

    protected processGetForCurrentUserAppV2(response: Response): Promise<MachineDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MachineDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineDTO[]>(null as any);
    }

    create(dto: MachineDTO): Promise<MachineDTO> {
        let url_ = this.baseUrl + "/api/Machine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<MachineDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MachineDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineDTO>(null as any);
    }

    update(dto: MachineDTO): Promise<MachineDTO> {
        let url_ = this.baseUrl + "/api/Machine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<MachineDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MachineDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineDTO>(null as any);
    }

    exportMachineOverview(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Machine/ExportMachineOverview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportMachineOverview(_response);
        });
    }

    protected processExportMachineOverview(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteMachineBySerialNumber(serialNumber: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Machine/DeleteMachineBySerialNumber?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMachineBySerialNumber(_response);
        });
    }

    protected processDeleteMachineBySerialNumber(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    upsertMachineNickname(serialNumber: string | null | undefined, nickname: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Machine/UpsertMachineNickname?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (nickname !== undefined && nickname !== null)
            url_ += "nickname=" + encodeURIComponent("" + nickname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertMachineNickname(_response);
        });
    }

    protected processUpsertMachineNickname(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MachineHistoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getAlarmHistory(pageNumber: number | undefined, pageSize: number | undefined, sortingSettings_Field: string | null | undefined, sortingSettings_SortOrder: SortOrder | null | undefined, machineId: number | undefined): Promise<PagedResponseOfAlarmHistory> {
        let url_ = this.baseUrl + "/api/MachineHistory/GetAlarmHistory?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortingSettings_Field !== undefined && sortingSettings_Field !== null)
            url_ += "SortingSettings.Field=" + encodeURIComponent("" + sortingSettings_Field) + "&";
        if (sortingSettings_SortOrder !== undefined && sortingSettings_SortOrder !== null)
            url_ += "SortingSettings.SortOrder=" + encodeURIComponent("" + sortingSettings_SortOrder) + "&";
        if (machineId === null)
            throw new globalThis.Error("The parameter 'machineId' cannot be null.");
        else if (machineId !== undefined)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlarmHistory(_response);
        });
    }

    protected processGetAlarmHistory(response: Response): Promise<PagedResponseOfAlarmHistory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfAlarmHistory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResponseOfAlarmHistory>(null as any);
    }

    getCleaningHistory(pageNumber: number | undefined, pageSize: number | undefined, sortingSettings_Field: string | null | undefined, sortingSettings_SortOrder: SortOrder | null | undefined, machineId: number | undefined): Promise<CleaningHistoriesDTO> {
        let url_ = this.baseUrl + "/api/MachineHistory/GetCleaningHistory?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortingSettings_Field !== undefined && sortingSettings_Field !== null)
            url_ += "SortingSettings.Field=" + encodeURIComponent("" + sortingSettings_Field) + "&";
        if (sortingSettings_SortOrder !== undefined && sortingSettings_SortOrder !== null)
            url_ += "SortingSettings.SortOrder=" + encodeURIComponent("" + sortingSettings_SortOrder) + "&";
        if (machineId === null)
            throw new globalThis.Error("The parameter 'machineId' cannot be null.");
        else if (machineId !== undefined)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCleaningHistory(_response);
        });
    }

    protected processGetCleaningHistory(response: Response): Promise<CleaningHistoriesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningHistoriesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CleaningHistoriesDTO>(null as any);
    }

    exportCleaningHistory(machineId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/MachineHistory/ExportCleaningHistory?";
        if (machineId === null)
            throw new globalThis.Error("The parameter 'machineId' cannot be null.");
        else if (machineId !== undefined)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportCleaningHistory(_response);
        });
    }

    protected processExportCleaningHistory(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportAlarmHistory(machineId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/MachineHistory/ExportAlarmHistory?";
        if (machineId === null)
            throw new globalThis.Error("The parameter 'machineId' cannot be null.");
        else if (machineId !== undefined)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAlarmHistory(_response);
        });
    }

    protected processExportAlarmHistory(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MachineStatisticsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    /**
     * @param machineId (optional) 
     * @deprecated
     */
    getMachineStatistics(machineId: number | undefined): Promise<MachineStatisticDTO> {
        let url_ = this.baseUrl + "/api/MachineStatistics/GetMachineStatistics?";
        if (machineId === null)
            throw new globalThis.Error("The parameter 'machineId' cannot be null.");
        else if (machineId !== undefined)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMachineStatistics(_response);
        });
    }

    protected processGetMachineStatistics(response: Response): Promise<MachineStatisticDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MachineStatisticDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineStatisticDTO>(null as any);
    }
}

export class MachineTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    get(): Promise<MachineTypeDTO[]> {
        let url_ = this.baseUrl + "/api/MachineType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MachineTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MachineTypeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineTypeDTO[]>(null as any);
    }

    create(dto: MachineTypeDTO): Promise<MachineTypeDTO> {
        let url_ = this.baseUrl + "/api/MachineType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<MachineTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MachineTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineTypeDTO>(null as any);
    }

    update(dto: MachineTypeDTO): Promise<MachineTypeDTO> {
        let url_ = this.baseUrl + "/api/MachineType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<MachineTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MachineTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineTypeDTO>(null as any);
    }

    delete(dto: MachineTypeDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/MachineType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TankStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    /**
     * @param machineId (optional) 
     * @deprecated
     */
    getById(machineId: number | undefined): Promise<TankStatusDTO> {
        let url_ = this.baseUrl + "/api/TankStatus/GetById?";
        if (machineId === null)
            throw new globalThis.Error("The parameter 'machineId' cannot be null.");
        else if (machineId !== undefined)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<TankStatusDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TankStatusDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TankStatusDTO>(null as any);
    }
}

export class OrganizationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    get(): Promise<OrganizationDTO[]> {
        let url_ = this.baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<OrganizationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDTO[]>(null as any);
    }

    post(dto: OrganizationDTO): Promise<OrganizationDTO> {
        let url_ = this.baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<OrganizationDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDTO>(null as any);
    }

    put(dto: OrganizationDTO): Promise<OrganizationDTO> {
        let url_ = this.baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<OrganizationDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDTO>(null as any);
    }

    delete(dto: OrganizationDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number | undefined): Promise<OrganizationDTO> {
        let url_ = this.baseUrl + "/api/Organization/GetById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<OrganizationDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDTO>(null as any);
    }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    removeMachineFromUser(machineId: number | undefined, userId: number | undefined): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/User/RemoveMachineFromUser?";
        if (machineId === null)
            throw new globalThis.Error("The parameter 'machineId' cannot be null.");
        else if (machineId !== undefined)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveMachineFromUser(_response);
        });
    }

    protected processRemoveMachineFromUser(response: Response): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    getCurrentUser(): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/User/GetCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    get(): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    post(dto: UserDTO): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    put(dto: UserDTO): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    delete(dto: UserDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportUserOverview(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/User/ExportUserOverview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportUserOverview(_response);
        });
    }

    protected processExportUserOverview(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateUserSetting(dto: UserSettingDTO): Promise<UserSettingDTO> {
        let url_ = this.baseUrl + "/api/User/UpdateUserSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserSetting(_response);
        });
    }

    protected processUpdateUserSetting(response: Response): Promise<UserSettingDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettingDTO>(null as any);
    }

    deleteSelf(): Promise<void> {
        let url_ = this.baseUrl + "/api/User/DeleteSelf";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSelf(_response);
        });
    }

    protected processDeleteSelf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    selfSignUp(dto: SelfSignUpRequestDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/User/SelfSignUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSelfSignUp(_response);
        });
    }

    protected processSelfSignUp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    signUp(userDto: WebHookUserDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/User/SignUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignUp(_response);
        });
    }

    protected processSignUp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resendInvitationEmail(dto: UserDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/User/ResendInvitationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendInvitationEmail(_response);
        });
    }

    protected processResendInvitationEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotificationSubscriptionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:4999";
    }

    getSubscriptionsForDevice(deviceId: string | null | undefined): Promise<NotificationSubscription[]> {
        let url_ = this.baseUrl + "/api/NotificationSubscription/GetSubscriptionsForDevice?";
        if (deviceId !== undefined && deviceId !== null)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubscriptionsForDevice(_response);
        });
    }

    protected processGetSubscriptionsForDevice(response: Response): Promise<NotificationSubscription[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSubscription.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription[]>(null as any);
    }

    getForCurrentUser(): Promise<NotificationSubscription[]> {
        let url_ = this.baseUrl + "/api/NotificationSubscription/GetForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForCurrentUser(_response);
        });
    }

    protected processGetForCurrentUser(response: Response): Promise<NotificationSubscription[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSubscription.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription[]>(null as any);
    }

    insert(notificationSubscriptionDTO: NotificationSubscriptionDTO): Promise<NotificationSubscription> {
        let url_ = this.baseUrl + "/api/NotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationSubscriptionDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<NotificationSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSubscription.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription>(null as any);
    }

    update(notificationSubscriptionDTO: NotificationSubscriptionDTO): Promise<NotificationSubscription> {
        let url_ = this.baseUrl + "/api/NotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationSubscriptionDTO);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<NotificationSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSubscription.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription>(null as any);
    }

    delete(notificationSubscriptionDTO: NotificationSubscriptionDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/NotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationSubscriptionDTO);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AgentDTO implements IAgentDTO {
    id!: number;
    name?: string | undefined;
    userIds?: number[] | undefined;
    machineIds?: number[] | undefined;

    constructor(data?: IAgentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["machineIds"])) {
                this.machineIds = [] as any;
                for (let item of _data["machineIds"])
                    this.machineIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AgentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.machineIds)) {
            data["machineIds"] = [];
            for (let item of this.machineIds)
                data["machineIds"].push(item);
        }
        return data;
    }
}

export interface IAgentDTO {
    id: number;
    name?: string | undefined;
    userIds?: number[] | undefined;
    machineIds?: number[] | undefined;
}

export class DeviceRegistrationDTO implements IDeviceRegistrationDTO {
    deviceToken?: string | undefined;
    deviceId?: string | undefined;

    constructor(data?: IDeviceRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceToken = _data["deviceToken"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): DeviceRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceToken"] = this.deviceToken;
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface IDeviceRegistrationDTO {
    deviceToken?: string | undefined;
    deviceId?: string | undefined;
}

export class MachineDTO implements IMachineDTO {
    id!: number;
    serialNumber!: string;
    deviceId!: string;
    linkSparePartManual?: string | undefined;
    linkUserManual?: string | undefined;
    linkVideo?: string | undefined;
    linkSupport?: string | undefined;
    linkConsumables?: string | undefined;
    linkSpareParts?: string | undefined;
    activated!: boolean;
    machineTypeName?: string | undefined;
    machineTypeImageUrl?: string | undefined;
    machineStateDto?: MachineStateDTO | undefined;
    activeAlarms?: MachineAlarmDTO[] | undefined;
    machineGroupType!: MachineGroupType;
    createdOn?: Date | undefined;
    expiryDate!: Date;
    latestStatistics?: MachineLatestStatisticsDTO | undefined;
    latestCleaning?: MachineLatestCleaningDTO | undefined;
    latestTankStatus?: MachineLatestTankStatusDTO | undefined;
    machineTypeId!: number;
    agentId?: number | undefined;
    agentName?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    userIds?: number[] | undefined;
    nickName?: string | undefined;

    constructor(data?: IMachineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.deviceId = _data["deviceId"];
            this.linkSparePartManual = _data["linkSparePartManual"];
            this.linkUserManual = _data["linkUserManual"];
            this.linkVideo = _data["linkVideo"];
            this.linkSupport = _data["linkSupport"];
            this.linkConsumables = _data["linkConsumables"];
            this.linkSpareParts = _data["linkSpareParts"];
            this.activated = _data["activated"];
            this.machineTypeName = _data["machineTypeName"];
            this.machineTypeImageUrl = _data["machineTypeImageUrl"];
            this.machineStateDto = _data["machineStateDto"] ? MachineStateDTO.fromJS(_data["machineStateDto"]) : undefined as any;
            if (Array.isArray(_data["activeAlarms"])) {
                this.activeAlarms = [] as any;
                for (let item of _data["activeAlarms"])
                    this.activeAlarms!.push(MachineAlarmDTO.fromJS(item));
            }
            this.machineGroupType = _data["machineGroupType"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : undefined as any;
            this.latestStatistics = _data["latestStatistics"] ? MachineLatestStatisticsDTO.fromJS(_data["latestStatistics"]) : undefined as any;
            this.latestCleaning = _data["latestCleaning"] ? MachineLatestCleaningDTO.fromJS(_data["latestCleaning"]) : undefined as any;
            this.latestTankStatus = _data["latestTankStatus"] ? MachineLatestTankStatusDTO.fromJS(_data["latestTankStatus"]) : undefined as any;
            this.machineTypeId = _data["machineTypeId"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.nickName = _data["nickName"];
        }
    }

    static fromJS(data: any): MachineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["deviceId"] = this.deviceId;
        data["linkSparePartManual"] = this.linkSparePartManual;
        data["linkUserManual"] = this.linkUserManual;
        data["linkVideo"] = this.linkVideo;
        data["linkSupport"] = this.linkSupport;
        data["linkConsumables"] = this.linkConsumables;
        data["linkSpareParts"] = this.linkSpareParts;
        data["activated"] = this.activated;
        data["machineTypeName"] = this.machineTypeName;
        data["machineTypeImageUrl"] = this.machineTypeImageUrl;
        data["machineStateDto"] = this.machineStateDto ? this.machineStateDto.toJSON() : undefined as any;
        if (Array.isArray(this.activeAlarms)) {
            data["activeAlarms"] = [];
            for (let item of this.activeAlarms)
                data["activeAlarms"].push(item ? item.toJSON() : undefined as any);
        }
        data["machineGroupType"] = this.machineGroupType;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["latestStatistics"] = this.latestStatistics ? this.latestStatistics.toJSON() : undefined as any;
        data["latestCleaning"] = this.latestCleaning ? this.latestCleaning.toJSON() : undefined as any;
        data["latestTankStatus"] = this.latestTankStatus ? this.latestTankStatus.toJSON() : undefined as any;
        data["machineTypeId"] = this.machineTypeId;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["nickName"] = this.nickName;
        return data;
    }
}

export interface IMachineDTO {
    id: number;
    serialNumber: string;
    deviceId: string;
    linkSparePartManual?: string | undefined;
    linkUserManual?: string | undefined;
    linkVideo?: string | undefined;
    linkSupport?: string | undefined;
    linkConsumables?: string | undefined;
    linkSpareParts?: string | undefined;
    activated: boolean;
    machineTypeName?: string | undefined;
    machineTypeImageUrl?: string | undefined;
    machineStateDto?: MachineStateDTO | undefined;
    activeAlarms?: MachineAlarmDTO[] | undefined;
    machineGroupType: MachineGroupType;
    createdOn?: Date | undefined;
    expiryDate: Date;
    latestStatistics?: MachineLatestStatisticsDTO | undefined;
    latestCleaning?: MachineLatestCleaningDTO | undefined;
    latestTankStatus?: MachineLatestTankStatusDTO | undefined;
    machineTypeId: number;
    agentId?: number | undefined;
    agentName?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    userIds?: number[] | undefined;
    nickName?: string | undefined;
}

export class MachineStateDTO implements IMachineStateDTO {
    id!: number;
    machineId!: number;
    machineStatus?: MachineStatus | undefined;
    connectionStatus!: ConnectionStatus;
    latestConnectionStateChange?: Date | undefined;
    washCompleteAt?: Date | undefined;

    constructor(data?: IMachineStateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.machineId = _data["machineId"];
            this.machineStatus = _data["machineStatus"];
            this.connectionStatus = _data["connectionStatus"];
            this.latestConnectionStateChange = _data["latestConnectionStateChange"] ? new Date(_data["latestConnectionStateChange"].toString()) : undefined as any;
            this.washCompleteAt = _data["washCompleteAt"] ? new Date(_data["washCompleteAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MachineStateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineStateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["machineId"] = this.machineId;
        data["machineStatus"] = this.machineStatus;
        data["connectionStatus"] = this.connectionStatus;
        data["latestConnectionStateChange"] = this.latestConnectionStateChange ? this.latestConnectionStateChange.toISOString() : undefined as any;
        data["washCompleteAt"] = this.washCompleteAt ? this.washCompleteAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IMachineStateDTO {
    id: number;
    machineId: number;
    machineStatus?: MachineStatus | undefined;
    connectionStatus: ConnectionStatus;
    latestConnectionStateChange?: Date | undefined;
    washCompleteAt?: Date | undefined;
}

export enum MachineStatus {
    Standby = 0,
    Running = 10,
    Paused = 20,
}

export enum ConnectionStatus {
    Online = 0,
    Offline = 1,
    Unknown = 2,
}

export class MachineAlarmDTO implements IMachineAlarmDTO {
    id!: number;
    alarmSeverity!: AlarmSeverity;
    alarmType!: AlarmType;
    alarmIndex!: number;
    errorDescription?: string | undefined;
    active!: boolean;
    machineId!: number;

    constructor(data?: IMachineAlarmDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alarmSeverity = _data["alarmSeverity"];
            this.alarmType = _data["alarmType"];
            this.alarmIndex = _data["alarmIndex"];
            this.errorDescription = _data["errorDescription"];
            this.active = _data["active"];
            this.machineId = _data["machineId"];
        }
    }

    static fromJS(data: any): MachineAlarmDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineAlarmDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alarmSeverity"] = this.alarmSeverity;
        data["alarmType"] = this.alarmType;
        data["alarmIndex"] = this.alarmIndex;
        data["errorDescription"] = this.errorDescription;
        data["active"] = this.active;
        data["machineId"] = this.machineId;
        return data;
    }
}

export interface IMachineAlarmDTO {
    id: number;
    alarmSeverity: AlarmSeverity;
    alarmType: AlarmType;
    alarmIndex: number;
    errorDescription?: string | undefined;
    active: boolean;
    machineId: number;
}

export enum AlarmSeverity {
    Alarm = 0,
    Warning = 1,
}

export enum AlarmType {
    Laser = 0,
    Micro = 1,
    Siemens_FW = 2,
    BR_FW = 3,
    MCC = 4,
    Siemens_PK = 5,
}

export enum MachineGroupType {
    Standard = 0,
    PW = 1,
    Laser = 2,
    MCC = 3,
}

export class MachineLatestStatisticsDTO implements IMachineLatestStatisticsDTO {
    totalWashHours?: number | undefined;
    washHoursSinceService?: number | undefined;
    washesLeftBeforeService?: number | undefined;
    washesLeftBeforeFilterChange?: number | undefined;
    totalWashes?: number | undefined;
    washesSinceService?: number | undefined;
    totalRinses?: number | undefined;
    rinsesSinceService?: number | undefined;
    totalRinseHours?: number | undefined;
    rinseHoursSinceService?: number | undefined;
    totalAniloxes?: number | undefined;
    aniloxesSinceService?: number | undefined;
    totalLaserHours?: number | undefined;
    laserHoursSinceService?: number | undefined;
    totalVacuumHours?: number | undefined;
    vacuumHoursSinceFilterChange?: number | undefined;
    vacuumHoursUntilNextFilter?: number | undefined;
    washesLeftBeforeLiquidChange?: number | undefined;

    constructor(data?: IMachineLatestStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWashHours = _data["totalWashHours"];
            this.washHoursSinceService = _data["washHoursSinceService"];
            this.washesLeftBeforeService = _data["washesLeftBeforeService"];
            this.washesLeftBeforeFilterChange = _data["washesLeftBeforeFilterChange"];
            this.totalWashes = _data["totalWashes"];
            this.washesSinceService = _data["washesSinceService"];
            this.totalRinses = _data["totalRinses"];
            this.rinsesSinceService = _data["rinsesSinceService"];
            this.totalRinseHours = _data["totalRinseHours"];
            this.rinseHoursSinceService = _data["rinseHoursSinceService"];
            this.totalAniloxes = _data["totalAniloxes"];
            this.aniloxesSinceService = _data["aniloxesSinceService"];
            this.totalLaserHours = _data["totalLaserHours"];
            this.laserHoursSinceService = _data["laserHoursSinceService"];
            this.totalVacuumHours = _data["totalVacuumHours"];
            this.vacuumHoursSinceFilterChange = _data["vacuumHoursSinceFilterChange"];
            this.vacuumHoursUntilNextFilter = _data["vacuumHoursUntilNextFilter"];
            this.washesLeftBeforeLiquidChange = _data["washesLeftBeforeLiquidChange"];
        }
    }

    static fromJS(data: any): MachineLatestStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineLatestStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWashHours"] = this.totalWashHours;
        data["washHoursSinceService"] = this.washHoursSinceService;
        data["washesLeftBeforeService"] = this.washesLeftBeforeService;
        data["washesLeftBeforeFilterChange"] = this.washesLeftBeforeFilterChange;
        data["totalWashes"] = this.totalWashes;
        data["washesSinceService"] = this.washesSinceService;
        data["totalRinses"] = this.totalRinses;
        data["rinsesSinceService"] = this.rinsesSinceService;
        data["totalRinseHours"] = this.totalRinseHours;
        data["rinseHoursSinceService"] = this.rinseHoursSinceService;
        data["totalAniloxes"] = this.totalAniloxes;
        data["aniloxesSinceService"] = this.aniloxesSinceService;
        data["totalLaserHours"] = this.totalLaserHours;
        data["laserHoursSinceService"] = this.laserHoursSinceService;
        data["totalVacuumHours"] = this.totalVacuumHours;
        data["vacuumHoursSinceFilterChange"] = this.vacuumHoursSinceFilterChange;
        data["vacuumHoursUntilNextFilter"] = this.vacuumHoursUntilNextFilter;
        data["washesLeftBeforeLiquidChange"] = this.washesLeftBeforeLiquidChange;
        return data;
    }
}

export interface IMachineLatestStatisticsDTO {
    totalWashHours?: number | undefined;
    washHoursSinceService?: number | undefined;
    washesLeftBeforeService?: number | undefined;
    washesLeftBeforeFilterChange?: number | undefined;
    totalWashes?: number | undefined;
    washesSinceService?: number | undefined;
    totalRinses?: number | undefined;
    rinsesSinceService?: number | undefined;
    totalRinseHours?: number | undefined;
    rinseHoursSinceService?: number | undefined;
    totalAniloxes?: number | undefined;
    aniloxesSinceService?: number | undefined;
    totalLaserHours?: number | undefined;
    laserHoursSinceService?: number | undefined;
    totalVacuumHours?: number | undefined;
    vacuumHoursSinceFilterChange?: number | undefined;
    vacuumHoursUntilNextFilter?: number | undefined;
    washesLeftBeforeLiquidChange?: number | undefined;
}

export class MachineLatestCleaningDTO implements IMachineLatestCleaningDTO {
    date?: string | undefined;
    time?: string | undefined;
    sequence?: number | undefined;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;
    recipe?: string | undefined;
    washTime?: number | undefined;
    tank?: number | undefined;
    temp?: number | undefined;
    rinse?: number | undefined;
    dry?: number | undefined;
    washSpeed?: number | undefined;
    rollId?: string | undefined;
    intensity?: string | undefined;
    color?: string | undefined;
    passes?: number | undefined;

    constructor(data?: IMachineLatestCleaningDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.time = _data["time"];
            this.sequence = _data["sequence"];
            this.employeeId = _data["employeeId"];
            this.placeHolder = _data["placeHolder"];
            this.recipe = _data["recipe"];
            this.washTime = _data["washTime"];
            this.tank = _data["tank"];
            this.temp = _data["temp"];
            this.rinse = _data["rinse"];
            this.dry = _data["dry"];
            this.washSpeed = _data["washSpeed"];
            this.rollId = _data["rollId"];
            this.intensity = _data["intensity"];
            this.color = _data["color"];
            this.passes = _data["passes"];
        }
    }

    static fromJS(data: any): MachineLatestCleaningDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineLatestCleaningDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["time"] = this.time;
        data["sequence"] = this.sequence;
        data["employeeId"] = this.employeeId;
        data["placeHolder"] = this.placeHolder;
        data["recipe"] = this.recipe;
        data["washTime"] = this.washTime;
        data["tank"] = this.tank;
        data["temp"] = this.temp;
        data["rinse"] = this.rinse;
        data["dry"] = this.dry;
        data["washSpeed"] = this.washSpeed;
        data["rollId"] = this.rollId;
        data["intensity"] = this.intensity;
        data["color"] = this.color;
        data["passes"] = this.passes;
        return data;
    }
}

export interface IMachineLatestCleaningDTO {
    date?: string | undefined;
    time?: string | undefined;
    sequence?: number | undefined;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;
    recipe?: string | undefined;
    washTime?: number | undefined;
    tank?: number | undefined;
    temp?: number | undefined;
    rinse?: number | undefined;
    dry?: number | undefined;
    washSpeed?: number | undefined;
    rollId?: string | undefined;
    intensity?: string | undefined;
    color?: string | undefined;
    passes?: number | undefined;
}

export class MachineLatestTankStatusDTO implements IMachineLatestTankStatusDTO {
    numberOfTanks?: number | undefined;
    temperatureTank1?: number | undefined;
    tempStatusTank1?: TankTempStatus | undefined;
    levelTank1?: TankLevel | undefined;
    temperatureTank2?: number | undefined;
    tempStatusTank2?: TankTempStatus | undefined;
    levelTank2?: TankLevel | undefined;

    constructor(data?: IMachineLatestTankStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfTanks = _data["numberOfTanks"];
            this.temperatureTank1 = _data["temperatureTank1"];
            this.tempStatusTank1 = _data["tempStatusTank1"];
            this.levelTank1 = _data["levelTank1"];
            this.temperatureTank2 = _data["temperatureTank2"];
            this.tempStatusTank2 = _data["tempStatusTank2"];
            this.levelTank2 = _data["levelTank2"];
        }
    }

    static fromJS(data: any): MachineLatestTankStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineLatestTankStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfTanks"] = this.numberOfTanks;
        data["temperatureTank1"] = this.temperatureTank1;
        data["tempStatusTank1"] = this.tempStatusTank1;
        data["levelTank1"] = this.levelTank1;
        data["temperatureTank2"] = this.temperatureTank2;
        data["tempStatusTank2"] = this.tempStatusTank2;
        data["levelTank2"] = this.levelTank2;
        return data;
    }
}

export interface IMachineLatestTankStatusDTO {
    numberOfTanks?: number | undefined;
    temperatureTank1?: number | undefined;
    tempStatusTank1?: TankTempStatus | undefined;
    levelTank1?: TankLevel | undefined;
    temperatureTank2?: number | undefined;
    tempStatusTank2?: TankTempStatus | undefined;
    levelTank2?: TankLevel | undefined;
}

export enum TankTempStatus {
    MaximumTemperature = 0,
    TemperatureOk = 1,
    MinimumTemperature = 2,
}

export enum TankLevel {
    MaximumLevel = 0,
    LevelOk = 1,
    BelowOk = 2,
    MinimumLevel = 3,
}

export class AddMachineDTO implements IAddMachineDTO {
    serialNumber?: string | undefined;
    pinCode?: string | undefined;

    constructor(data?: IAddMachineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.pinCode = _data["pinCode"];
        }
    }

    static fromJS(data: any): AddMachineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddMachineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["pinCode"] = this.pinCode;
        return data;
    }
}

export interface IAddMachineDTO {
    serialNumber?: string | undefined;
    pinCode?: string | undefined;
}

export class MachineAppDTO extends MachineDTO implements IMachineAppDTO {
    statistics?: MachineStatisticDTO | undefined;
    alarmHistory?: PagedResponseOfAlarmHistory | undefined;
    tankStatus?: TankStatusDTO | undefined;
    currentState?: MachineCurrentStateDTO | undefined;

    constructor(data?: IMachineAppDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statistics = _data["statistics"] ? MachineStatisticDTO.fromJS(_data["statistics"]) : undefined as any;
            this.alarmHistory = _data["alarmHistory"] ? PagedResponseOfAlarmHistory.fromJS(_data["alarmHistory"]) : undefined as any;
            this.tankStatus = _data["tankStatus"] ? TankStatusDTO.fromJS(_data["tankStatus"]) : undefined as any;
            this.currentState = _data["currentState"] ? MachineCurrentStateDTO.fromJS(_data["currentState"]) : undefined as any;
        }
    }

    static override fromJS(data: any): MachineAppDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineAppDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statistics"] = this.statistics ? this.statistics.toJSON() : undefined as any;
        data["alarmHistory"] = this.alarmHistory ? this.alarmHistory.toJSON() : undefined as any;
        data["tankStatus"] = this.tankStatus ? this.tankStatus.toJSON() : undefined as any;
        data["currentState"] = this.currentState ? this.currentState.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineAppDTO extends IMachineDTO {
    statistics?: MachineStatisticDTO | undefined;
    alarmHistory?: PagedResponseOfAlarmHistory | undefined;
    tankStatus?: TankStatusDTO | undefined;
    currentState?: MachineCurrentStateDTO | undefined;
}

export class MachineStatisticDTO implements IMachineStatisticDTO {
    machineGroupType!: MachineGroupType;
    statistics?: MachineStatisticDTO | undefined;

    protected _discriminator: string;

    constructor(data?: IMachineStatisticDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "MachineStatisticDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.machineGroupType = _data["machineGroupType"];
            this.statistics = _data["statistics"] ? MachineStatisticDTO.fromJS(_data["statistics"]) : undefined as any;
        }
    }

    static fromJS(data: any): MachineStatisticDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "LaserMachineStatisticDTO") {
            let result = new LaserMachineStatisticDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PWMachineStatisticDTO") {
            let result = new PWMachineStatisticDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StandardMachineStatisticDTO") {
            let result = new StandardMachineStatisticDTO();
            result.init(data);
            return result;
        }
        let result = new MachineStatisticDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["machineGroupType"] = this.machineGroupType;
        data["statistics"] = this.statistics ? this.statistics.toJSON() : undefined as any;
        return data;
    }
}

export interface IMachineStatisticDTO {
    machineGroupType: MachineGroupType;
    statistics?: MachineStatisticDTO | undefined;
}

export class LaserMachineStatisticDTO extends MachineStatisticDTO implements ILaserMachineStatisticDTO {
    totalAniloxes?: number | undefined;
    aniloxesSinceService?: number | undefined;
    totalLaserHours?: number | undefined;
    laserHoursSinceService?: number | undefined;
    totalVacuumHours?: number | undefined;
    vacuumHoursSinceFilterChange?: number | undefined;
    vacuumHoursUntilNextFilter?: number | undefined;

    constructor(data?: ILaserMachineStatisticDTO) {
        super(data);
        this._discriminator = "LaserMachineStatisticDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalAniloxes = _data["totalAniloxes"];
            this.aniloxesSinceService = _data["aniloxesSinceService"];
            this.totalLaserHours = _data["totalLaserHours"];
            this.laserHoursSinceService = _data["laserHoursSinceService"];
            this.totalVacuumHours = _data["totalVacuumHours"];
            this.vacuumHoursSinceFilterChange = _data["vacuumHoursSinceFilterChange"];
            this.vacuumHoursUntilNextFilter = _data["vacuumHoursUntilNextFilter"];
        }
    }

    static override fromJS(data: any): LaserMachineStatisticDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LaserMachineStatisticDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAniloxes"] = this.totalAniloxes;
        data["aniloxesSinceService"] = this.aniloxesSinceService;
        data["totalLaserHours"] = this.totalLaserHours;
        data["laserHoursSinceService"] = this.laserHoursSinceService;
        data["totalVacuumHours"] = this.totalVacuumHours;
        data["vacuumHoursSinceFilterChange"] = this.vacuumHoursSinceFilterChange;
        data["vacuumHoursUntilNextFilter"] = this.vacuumHoursUntilNextFilter;
        super.toJSON(data);
        return data;
    }
}

export interface ILaserMachineStatisticDTO extends IMachineStatisticDTO {
    totalAniloxes?: number | undefined;
    aniloxesSinceService?: number | undefined;
    totalLaserHours?: number | undefined;
    laserHoursSinceService?: number | undefined;
    totalVacuumHours?: number | undefined;
    vacuumHoursSinceFilterChange?: number | undefined;
    vacuumHoursUntilNextFilter?: number | undefined;
}

export class PWMachineStatisticDTO extends MachineStatisticDTO implements IPWMachineStatisticDTO {
    totalWashHours?: number | undefined;
    washHoursSinceService?: number | undefined;
    washesUntilNextFilter?: number | undefined;
    washHoursUntilNextService?: number | undefined;
    washHoursUntilNextFilter?: number | undefined;

    constructor(data?: IPWMachineStatisticDTO) {
        super(data);
        this._discriminator = "PWMachineStatisticDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalWashHours = _data["totalWashHours"];
            this.washHoursSinceService = _data["washHoursSinceService"];
            this.washesUntilNextFilter = _data["washesUntilNextFilter"];
            this.washHoursUntilNextService = _data["washHoursUntilNextService"];
            this.washHoursUntilNextFilter = _data["washHoursUntilNextFilter"];
        }
    }

    static override fromJS(data: any): PWMachineStatisticDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PWMachineStatisticDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWashHours"] = this.totalWashHours;
        data["washHoursSinceService"] = this.washHoursSinceService;
        data["washesUntilNextFilter"] = this.washesUntilNextFilter;
        data["washHoursUntilNextService"] = this.washHoursUntilNextService;
        data["washHoursUntilNextFilter"] = this.washHoursUntilNextFilter;
        super.toJSON(data);
        return data;
    }
}

export interface IPWMachineStatisticDTO extends IMachineStatisticDTO {
    totalWashHours?: number | undefined;
    washHoursSinceService?: number | undefined;
    washesUntilNextFilter?: number | undefined;
    washHoursUntilNextService?: number | undefined;
    washHoursUntilNextFilter?: number | undefined;
}

export class StandardMachineStatisticDTO extends MachineStatisticDTO implements IStandardMachineStatisticDTO {
    totalWashes?: number | undefined;
    washesSinceService?: number | undefined;
    totalWashHours?: number | undefined;
    washHoursSinceService?: number | undefined;
    totalRinses?: number | undefined;
    rinsesSinceService?: number | undefined;
    totalRinseHours?: number | undefined;
    rinseHoursSinceService?: number | undefined;
    washesUntilNextService?: number | undefined;
    washesUntilNextFilter?: number | undefined;

    constructor(data?: IStandardMachineStatisticDTO) {
        super(data);
        this._discriminator = "StandardMachineStatisticDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalWashes = _data["totalWashes"];
            this.washesSinceService = _data["washesSinceService"];
            this.totalWashHours = _data["totalWashHours"];
            this.washHoursSinceService = _data["washHoursSinceService"];
            this.totalRinses = _data["totalRinses"];
            this.rinsesSinceService = _data["rinsesSinceService"];
            this.totalRinseHours = _data["totalRinseHours"];
            this.rinseHoursSinceService = _data["rinseHoursSinceService"];
            this.washesUntilNextService = _data["washesUntilNextService"];
            this.washesUntilNextFilter = _data["washesUntilNextFilter"];
        }
    }

    static override fromJS(data: any): StandardMachineStatisticDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StandardMachineStatisticDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWashes"] = this.totalWashes;
        data["washesSinceService"] = this.washesSinceService;
        data["totalWashHours"] = this.totalWashHours;
        data["washHoursSinceService"] = this.washHoursSinceService;
        data["totalRinses"] = this.totalRinses;
        data["rinsesSinceService"] = this.rinsesSinceService;
        data["totalRinseHours"] = this.totalRinseHours;
        data["rinseHoursSinceService"] = this.rinseHoursSinceService;
        data["washesUntilNextService"] = this.washesUntilNextService;
        data["washesUntilNextFilter"] = this.washesUntilNextFilter;
        super.toJSON(data);
        return data;
    }
}

export interface IStandardMachineStatisticDTO extends IMachineStatisticDTO {
    totalWashes?: number | undefined;
    washesSinceService?: number | undefined;
    totalWashHours?: number | undefined;
    washHoursSinceService?: number | undefined;
    totalRinses?: number | undefined;
    rinsesSinceService?: number | undefined;
    totalRinseHours?: number | undefined;
    rinseHoursSinceService?: number | undefined;
    washesUntilNextService?: number | undefined;
    washesUntilNextFilter?: number | undefined;
}

export class PagedResponseOfAlarmHistory implements IPagedResponseOfAlarmHistory {
    totalItems!: number;
    data?: AlarmHistory[] | undefined;

    constructor(data?: IPagedResponseOfAlarmHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalItems = _data["totalItems"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AlarmHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResponseOfAlarmHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfAlarmHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalItems"] = this.totalItems;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResponseOfAlarmHistory {
    totalItems: number;
    data?: AlarmHistory[] | undefined;
}

export abstract class CosmosModelBase implements ICosmosModelBase {
    id?: string | undefined;
    type!: FlexoWashType;
    iitfDecoder?: string | undefined;
    deviceId?: string | undefined;
    timestamp!: Date;
    version?: string | undefined;

    constructor(data?: ICosmosModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["Type"];
            this.iitfDecoder = _data["iitfDecoder"];
            this.deviceId = _data["deviceId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.version = _data["Version"];
        }
    }

    static fromJS(data: any): CosmosModelBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CosmosModelBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["Type"] = this.type;
        data["iitfDecoder"] = this.iitfDecoder;
        data["deviceId"] = this.deviceId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["Version"] = this.version;
        return data;
    }
}

export interface ICosmosModelBase {
    id?: string | undefined;
    type: FlexoWashType;
    iitfDecoder?: string | undefined;
    deviceId?: string | undefined;
    timestamp: Date;
    version?: string | undefined;
}

export class AlarmHistory extends CosmosModelBase implements IAlarmHistory {
    alarmType!: AlarmType;
    errorDescription?: string | undefined;
    alarmSeverity!: AlarmSeverity;
    alarmIndex!: number;
    isOpen!: boolean;

    constructor(data?: IAlarmHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.alarmType = _data["alarmType"];
            this.errorDescription = _data["errorDescription"];
            this.alarmSeverity = _data["alarmSeverity"];
            this.alarmIndex = _data["alarmIndex"];
            this.isOpen = _data["isOpen"];
        }
    }

    static override fromJS(data: any): AlarmHistory {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmType"] = this.alarmType;
        data["errorDescription"] = this.errorDescription;
        data["alarmSeverity"] = this.alarmSeverity;
        data["alarmIndex"] = this.alarmIndex;
        data["isOpen"] = this.isOpen;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmHistory extends ICosmosModelBase {
    alarmType: AlarmType;
    errorDescription?: string | undefined;
    alarmSeverity: AlarmSeverity;
    alarmIndex: number;
    isOpen: boolean;
}

export enum FlexoWashType {
    AlarmHistory = 0,
    CleaningHistory = 1,
    MachineStatus = 2,
    MachineStatistic = 3,
    MachineHeartbeat = 4,
    TankStatus = 5,
}

export class TankStatusDTO implements ITankStatusDTO {
    numberOfTanks!: number;
    tank1?: Tank | undefined;
    tank2?: Tank | undefined;

    constructor(data?: ITankStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfTanks = _data["numberOfTanks"];
            this.tank1 = _data["tank1"] ? Tank.fromJS(_data["tank1"]) : undefined as any;
            this.tank2 = _data["tank2"] ? Tank.fromJS(_data["tank2"]) : undefined as any;
        }
    }

    static fromJS(data: any): TankStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TankStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfTanks"] = this.numberOfTanks;
        data["tank1"] = this.tank1 ? this.tank1.toJSON() : undefined as any;
        data["tank2"] = this.tank2 ? this.tank2.toJSON() : undefined as any;
        return data;
    }
}

export interface ITankStatusDTO {
    numberOfTanks: number;
    tank1?: Tank | undefined;
    tank2?: Tank | undefined;
}

export class Tank implements ITank {
    temperature!: number;
    tempStatus!: TankTempStatus;
    level!: TankLevel;

    constructor(data?: ITank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temperature = _data["temperature"];
            this.tempStatus = _data["tempStatus"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): Tank {
        data = typeof data === 'object' ? data : {};
        let result = new Tank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature"] = this.temperature;
        data["tempStatus"] = this.tempStatus;
        data["level"] = this.level;
        return data;
    }
}

export interface ITank {
    temperature: number;
    tempStatus: TankTempStatus;
    level: TankLevel;
}

export class MachineCurrentStateDTO implements IMachineCurrentStateDTO {
    deviceId?: string | undefined;
    machineState!: MachineState;
    connectionState!: ConnectionState;
    latestConnectionStateChange?: Date | undefined;
    remainingTime?: number | undefined;

    constructor(data?: IMachineCurrentStateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.machineState = _data["machineState"];
            this.connectionState = _data["connectionState"];
            this.latestConnectionStateChange = _data["latestConnectionStateChange"] ? new Date(_data["latestConnectionStateChange"].toString()) : undefined as any;
            this.remainingTime = _data["remainingTime"];
        }
    }

    static fromJS(data: any): MachineCurrentStateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineCurrentStateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["machineState"] = this.machineState;
        data["connectionState"] = this.connectionState;
        data["latestConnectionStateChange"] = this.latestConnectionStateChange ? this.latestConnectionStateChange.toISOString() : undefined as any;
        data["remainingTime"] = this.remainingTime;
        return data;
    }
}

export interface IMachineCurrentStateDTO {
    deviceId?: string | undefined;
    machineState: MachineState;
    connectionState: ConnectionState;
    latestConnectionStateChange?: Date | undefined;
    remainingTime?: number | undefined;
}

export enum MachineState {
    Running = 0,
    Standby = 1,
    Paused = 2,
    Unknown = 3,
}

export enum ConnectionState {
    Online = 0,
    Offline = 1,
    Unknown = 2,
}

export enum SortOrder {
    Asc = 0,
    Desc = 1,
}

export class CleaningHistoriesDTO implements ICleaningHistoriesDTO {
    cleaningType!: CleaningType;
    pagedCleaningHistory?: PagedResponseOfCleaningHistoryDTO | undefined;

    constructor(data?: ICleaningHistoriesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cleaningType = _data["cleaningType"];
            this.pagedCleaningHistory = _data["pagedCleaningHistory"] ? PagedResponseOfCleaningHistoryDTO.fromJS(_data["pagedCleaningHistory"]) : undefined as any;
        }
    }

    static fromJS(data: any): CleaningHistoriesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CleaningHistoriesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cleaningType"] = this.cleaningType;
        data["pagedCleaningHistory"] = this.pagedCleaningHistory ? this.pagedCleaningHistory.toJSON() : undefined as any;
        return data;
    }
}

export interface ICleaningHistoriesDTO {
    cleaningType: CleaningType;
    pagedCleaningHistory?: PagedResponseOfCleaningHistoryDTO | undefined;
}

export enum CleaningType {
    Unknown = 0,
    PLC_FW = 1,
    Standard = 2,
    PW = 3,
    Laser = 4,
}

export class PagedResponseOfCleaningHistoryDTO implements IPagedResponseOfCleaningHistoryDTO {
    totalItems!: number;
    data?: CleaningHistoryDTO[] | undefined;

    constructor(data?: IPagedResponseOfCleaningHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalItems = _data["totalItems"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CleaningHistoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResponseOfCleaningHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfCleaningHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalItems"] = this.totalItems;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResponseOfCleaningHistoryDTO {
    totalItems: number;
    data?: CleaningHistoryDTO[] | undefined;
}

export class CleaningHistoryDTO implements ICleaningHistoryDTO {
    id?: string | undefined;
    cleaningType!: CleaningType;
    timestamp!: Date;

    protected _discriminator: string;

    constructor(data?: ICleaningHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "CleaningHistoryDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cleaningType = _data["cleaningType"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CleaningHistoryDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "LaserCleaningHistoryDTO") {
            let result = new LaserCleaningHistoryDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PLCFWCleaningHistoryDTO") {
            let result = new PLCFWCleaningHistoryDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PWCleaningHistoryDTO") {
            let result = new PWCleaningHistoryDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StandardCleaningHistoryDTO") {
            let result = new StandardCleaningHistoryDTO();
            result.init(data);
            return result;
        }
        let result = new CleaningHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["id"] = this.id;
        data["cleaningType"] = this.cleaningType;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        return data;
    }
}

export interface ICleaningHistoryDTO {
    id?: string | undefined;
    cleaningType: CleaningType;
    timestamp: Date;
}

export class LaserCleaningHistoryDTO extends CleaningHistoryDTO implements ILaserCleaningHistoryDTO {
    date?: string | undefined;
    time?: string | undefined;
    rollId?: string | undefined;
    sequence!: number;
    intensity?: string | undefined;
    color?: string | undefined;
    passes!: number;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;

    constructor(data?: ILaserCleaningHistoryDTO) {
        super(data);
        this._discriminator = "LaserCleaningHistoryDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
            this.time = _data["time"];
            this.rollId = _data["rollId"];
            this.sequence = _data["sequence"];
            this.intensity = _data["intensity"];
            this.color = _data["color"];
            this.passes = _data["passes"];
            this.employeeId = _data["employeeId"];
            this.placeHolder = _data["placeHolder"];
        }
    }

    static override fromJS(data: any): LaserCleaningHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LaserCleaningHistoryDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["time"] = this.time;
        data["rollId"] = this.rollId;
        data["sequence"] = this.sequence;
        data["intensity"] = this.intensity;
        data["color"] = this.color;
        data["passes"] = this.passes;
        data["employeeId"] = this.employeeId;
        data["placeHolder"] = this.placeHolder;
        super.toJSON(data);
        return data;
    }
}

export interface ILaserCleaningHistoryDTO extends ICleaningHistoryDTO {
    date?: string | undefined;
    time?: string | undefined;
    rollId?: string | undefined;
    sequence: number;
    intensity?: string | undefined;
    color?: string | undefined;
    passes: number;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;
}

export class PLCFWCleaningHistoryDTO extends CleaningHistoryDTO implements IPLCFWCleaningHistoryDTO {
    date?: string | undefined;
    time?: string | undefined;
    rollId?: string | undefined;
    sequence!: number;
    recipe?: string | undefined;
    washTime!: number;
    tank!: number;
    temp!: number;
    rinse!: number;
    dry!: number;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;

    constructor(data?: IPLCFWCleaningHistoryDTO) {
        super(data);
        this._discriminator = "PLCFWCleaningHistoryDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
            this.time = _data["time"];
            this.rollId = _data["rollId"];
            this.sequence = _data["sequence"];
            this.recipe = _data["recipe"];
            this.washTime = _data["washTime"];
            this.tank = _data["tank"];
            this.temp = _data["temp"];
            this.rinse = _data["rinse"];
            this.dry = _data["dry"];
            this.employeeId = _data["employeeId"];
            this.placeHolder = _data["placeHolder"];
        }
    }

    static override fromJS(data: any): PLCFWCleaningHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PLCFWCleaningHistoryDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["time"] = this.time;
        data["rollId"] = this.rollId;
        data["sequence"] = this.sequence;
        data["recipe"] = this.recipe;
        data["washTime"] = this.washTime;
        data["tank"] = this.tank;
        data["temp"] = this.temp;
        data["rinse"] = this.rinse;
        data["dry"] = this.dry;
        data["employeeId"] = this.employeeId;
        data["placeHolder"] = this.placeHolder;
        super.toJSON(data);
        return data;
    }
}

export interface IPLCFWCleaningHistoryDTO extends ICleaningHistoryDTO {
    date?: string | undefined;
    time?: string | undefined;
    rollId?: string | undefined;
    sequence: number;
    recipe?: string | undefined;
    washTime: number;
    tank: number;
    temp: number;
    rinse: number;
    dry: number;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;
}

export class PWCleaningHistoryDTO extends CleaningHistoryDTO implements IPWCleaningHistoryDTO {
    date?: string | undefined;
    time?: string | undefined;
    sequence!: number;
    recipe?: string | undefined;
    washTime!: number;
    tank!: number;
    temp!: number;
    washSpeed!: number;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;

    constructor(data?: IPWCleaningHistoryDTO) {
        super(data);
        this._discriminator = "PWCleaningHistoryDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
            this.time = _data["time"];
            this.sequence = _data["sequence"];
            this.recipe = _data["recipe"];
            this.washTime = _data["washTime"];
            this.tank = _data["tank"];
            this.temp = _data["temp"];
            this.washSpeed = _data["washSpeed"];
            this.employeeId = _data["employeeId"];
            this.placeHolder = _data["placeHolder"];
        }
    }

    static override fromJS(data: any): PWCleaningHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PWCleaningHistoryDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["time"] = this.time;
        data["sequence"] = this.sequence;
        data["recipe"] = this.recipe;
        data["washTime"] = this.washTime;
        data["tank"] = this.tank;
        data["temp"] = this.temp;
        data["washSpeed"] = this.washSpeed;
        data["employeeId"] = this.employeeId;
        data["placeHolder"] = this.placeHolder;
        super.toJSON(data);
        return data;
    }
}

export interface IPWCleaningHistoryDTO extends ICleaningHistoryDTO {
    date?: string | undefined;
    time?: string | undefined;
    sequence: number;
    recipe?: string | undefined;
    washTime: number;
    tank: number;
    temp: number;
    washSpeed: number;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;
}

export class StandardCleaningHistoryDTO extends CleaningHistoryDTO implements IStandardCleaningHistoryDTO {
    date?: string | undefined;
    time?: string | undefined;
    sequence!: number;
    recipe?: string | undefined;
    washTime!: number;
    tank!: number;
    temp!: number;
    rinse!: number;
    dry!: number;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;

    constructor(data?: IStandardCleaningHistoryDTO) {
        super(data);
        this._discriminator = "StandardCleaningHistoryDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
            this.time = _data["time"];
            this.sequence = _data["sequence"];
            this.recipe = _data["recipe"];
            this.washTime = _data["washTime"];
            this.tank = _data["tank"];
            this.temp = _data["temp"];
            this.rinse = _data["rinse"];
            this.dry = _data["dry"];
            this.employeeId = _data["employeeId"];
            this.placeHolder = _data["placeHolder"];
        }
    }

    static override fromJS(data: any): StandardCleaningHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StandardCleaningHistoryDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["time"] = this.time;
        data["sequence"] = this.sequence;
        data["recipe"] = this.recipe;
        data["washTime"] = this.washTime;
        data["tank"] = this.tank;
        data["temp"] = this.temp;
        data["rinse"] = this.rinse;
        data["dry"] = this.dry;
        data["employeeId"] = this.employeeId;
        data["placeHolder"] = this.placeHolder;
        super.toJSON(data);
        return data;
    }
}

export interface IStandardCleaningHistoryDTO extends ICleaningHistoryDTO {
    date?: string | undefined;
    time?: string | undefined;
    sequence: number;
    recipe?: string | undefined;
    washTime: number;
    tank: number;
    temp: number;
    rinse: number;
    dry: number;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;
}

export class MachineTypeDTO implements IMachineTypeDTO {
    id!: number;
    name?: string | undefined;
    machineGroupId!: number;
    machineGroupType!: MachineGroupType;
    imageName?: string | undefined;
    imageBase64?: string | undefined;
    machineIds?: number[] | undefined;

    constructor(data?: IMachineTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.machineGroupId = _data["machineGroupId"];
            this.machineGroupType = _data["machineGroupType"];
            this.imageName = _data["imageName"];
            this.imageBase64 = _data["imageBase64"];
            if (Array.isArray(_data["machineIds"])) {
                this.machineIds = [] as any;
                for (let item of _data["machineIds"])
                    this.machineIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MachineTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MachineTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["machineGroupId"] = this.machineGroupId;
        data["machineGroupType"] = this.machineGroupType;
        data["imageName"] = this.imageName;
        data["imageBase64"] = this.imageBase64;
        if (Array.isArray(this.machineIds)) {
            data["machineIds"] = [];
            for (let item of this.machineIds)
                data["machineIds"].push(item);
        }
        return data;
    }
}

export interface IMachineTypeDTO {
    id: number;
    name?: string | undefined;
    machineGroupId: number;
    machineGroupType: MachineGroupType;
    imageName?: string | undefined;
    imageBase64?: string | undefined;
    machineIds?: number[] | undefined;
}

export class OrganizationDTO implements IOrganizationDTO {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;
    machineIds?: number[] | undefined;

    constructor(data?: IOrganizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["machineIds"])) {
                this.machineIds = [] as any;
                for (let item of _data["machineIds"])
                    this.machineIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.machineIds)) {
            data["machineIds"] = [];
            for (let item of this.machineIds)
                data["machineIds"].push(item);
        }
        return data;
    }
}

export interface IOrganizationDTO {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    machineIds?: number[] | undefined;
}

export class UserDTO implements IUserDTO {
    id!: number;
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role!: UserRole;
    agentId?: number | undefined;
    userSettingDTO?: UserSettingDTO | undefined;
    machineIds?: number[] | undefined;
    deviceIds?: number[] | undefined;
    lastSeenWeb?: Date | undefined;
    lastSeenApp?: Date | undefined;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.role = _data["role"];
            this.agentId = _data["agentId"];
            this.userSettingDTO = _data["userSettingDTO"] ? UserSettingDTO.fromJS(_data["userSettingDTO"]) : undefined as any;
            if (Array.isArray(_data["machineIds"])) {
                this.machineIds = [] as any;
                for (let item of _data["machineIds"])
                    this.machineIds!.push(item);
            }
            if (Array.isArray(_data["deviceIds"])) {
                this.deviceIds = [] as any;
                for (let item of _data["deviceIds"])
                    this.deviceIds!.push(item);
            }
            this.lastSeenWeb = _data["lastSeenWeb"] ? new Date(_data["lastSeenWeb"].toString()) : undefined as any;
            this.lastSeenApp = _data["lastSeenApp"] ? new Date(_data["lastSeenApp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["role"] = this.role;
        data["agentId"] = this.agentId;
        data["userSettingDTO"] = this.userSettingDTO ? this.userSettingDTO.toJSON() : undefined as any;
        if (Array.isArray(this.machineIds)) {
            data["machineIds"] = [];
            for (let item of this.machineIds)
                data["machineIds"].push(item);
        }
        if (Array.isArray(this.deviceIds)) {
            data["deviceIds"] = [];
            for (let item of this.deviceIds)
                data["deviceIds"].push(item);
        }
        data["lastSeenWeb"] = this.lastSeenWeb ? this.lastSeenWeb.toISOString() : undefined as any;
        data["lastSeenApp"] = this.lastSeenApp ? this.lastSeenApp.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserDTO {
    id: number;
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role: UserRole;
    agentId?: number | undefined;
    userSettingDTO?: UserSettingDTO | undefined;
    machineIds?: number[] | undefined;
    deviceIds?: number[] | undefined;
    lastSeenWeb?: Date | undefined;
    lastSeenApp?: Date | undefined;
}

export enum UserRole {
    GlobalAdmin = 0,
    User = 10,
}

export class UserSettingDTO implements IUserSettingDTO {
    id!: number;
    language!: Language;
    workDays?: DayOfWeek[] | undefined;
    timezoneId?: string | undefined;
    workingHoursStart!: number;
    workingHoursEnd!: number;
    userId!: number;

    constructor(data?: IUserSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            if (Array.isArray(_data["workDays"])) {
                this.workDays = [] as any;
                for (let item of _data["workDays"])
                    this.workDays!.push(item);
            }
            this.timezoneId = _data["timezoneId"];
            this.workingHoursStart = _data["workingHoursStart"];
            this.workingHoursEnd = _data["workingHoursEnd"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        if (Array.isArray(this.workDays)) {
            data["workDays"] = [];
            for (let item of this.workDays)
                data["workDays"].push(item);
        }
        data["timezoneId"] = this.timezoneId;
        data["workingHoursStart"] = this.workingHoursStart;
        data["workingHoursEnd"] = this.workingHoursEnd;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserSettingDTO {
    id: number;
    language: Language;
    workDays?: DayOfWeek[] | undefined;
    timezoneId?: string | undefined;
    workingHoursStart: number;
    workingHoursEnd: number;
    userId: number;
}

export enum Language {
    English = 0,
    Danish = 1,
    German = 2,
    Spanish = 3,
    French = 4,
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class SelfSignUpRequestDTO implements ISelfSignUpRequestDTO {
    name!: string;
    email!: string;

    constructor(data?: ISelfSignUpRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SelfSignUpRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelfSignUpRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface ISelfSignUpRequestDTO {
    name: string;
    email: string;
}

export class WebHookUserDTO implements IWebHookUserDTO {
    email?: string | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    extension_Role?: string | undefined;

    constructor(data?: IWebHookUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.extension_Role = _data["extension_Role"];
        }
    }

    static fromJS(data: any): WebHookUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["extension_Role"] = this.extension_Role;
        return data;
    }
}

export interface IWebHookUserDTO {
    email?: string | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    extension_Role?: string | undefined;
}

export abstract class ModelBase implements IModelBase {
    id!: number;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted!: boolean;

    constructor(data?: IModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ModelBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ModelBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IModelBase {
    id: number;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted: boolean;
}

export class NotificationSubscription extends ModelBase implements INotificationSubscription {
    notifyPush!: boolean;
    notifyEmail!: boolean;
    notifySms!: boolean;
    userId!: number;
    user?: User | undefined;
    machineId!: number;
    machine?: Machine | undefined;

    constructor(data?: INotificationSubscription) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notifyPush = _data["notifyPush"];
            this.notifyEmail = _data["notifyEmail"];
            this.notifySms = _data["notifySms"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.machineId = _data["machineId"];
            this.machine = _data["machine"] ? Machine.fromJS(_data["machine"]) : undefined as any;
        }
    }

    static override fromJS(data: any): NotificationSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscription();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyPush"] = this.notifyPush;
        data["notifyEmail"] = this.notifyEmail;
        data["notifySms"] = this.notifySms;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["machineId"] = this.machineId;
        data["machine"] = this.machine ? this.machine.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationSubscription extends IModelBase {
    notifyPush: boolean;
    notifyEmail: boolean;
    notifySms: boolean;
    userId: number;
    user?: User | undefined;
    machineId: number;
    machine?: Machine | undefined;
}

export class User extends ModelBase implements IUser {
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    role!: UserRole;
    agentId?: number | undefined;
    agent?: Agent | undefined;
    devices?: Device[] | undefined;
    machines?: Machine[] | undefined;
    userSettingId!: number;
    userSetting?: UserSetting | undefined;
    lastSeenWeb?: Date | undefined;
    lastSeenApp?: Date | undefined;

    constructor(data?: IUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(Machine.fromJS(item));
            }
            this.userSettingId = _data["userSettingId"];
            this.userSetting = _data["userSetting"] ? UserSetting.fromJS(_data["userSetting"]) : undefined as any;
            this.lastSeenWeb = _data["lastSeenWeb"] ? new Date(_data["lastSeenWeb"].toString()) : undefined as any;
            this.lastSeenApp = _data["lastSeenApp"] ? new Date(_data["lastSeenApp"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["role"] = this.role;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item ? item.toJSON() : undefined as any);
        }
        data["userSettingId"] = this.userSettingId;
        data["userSetting"] = this.userSetting ? this.userSetting.toJSON() : undefined as any;
        data["lastSeenWeb"] = this.lastSeenWeb ? this.lastSeenWeb.toISOString() : undefined as any;
        data["lastSeenApp"] = this.lastSeenApp ? this.lastSeenApp.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUser extends IModelBase {
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    role: UserRole;
    agentId?: number | undefined;
    agent?: Agent | undefined;
    devices?: Device[] | undefined;
    machines?: Machine[] | undefined;
    userSettingId: number;
    userSetting?: UserSetting | undefined;
    lastSeenWeb?: Date | undefined;
    lastSeenApp?: Date | undefined;
}

export class Agent extends ModelBase implements IAgent {
    name?: string | undefined;
    user?: User[] | undefined;
    machines?: Machine[] | undefined;

    constructor(data?: IAgent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["user"])) {
                this.user = [] as any;
                for (let item of _data["user"])
                    this.user!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(Machine.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Agent {
        data = typeof data === 'object' ? data : {};
        let result = new Agent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.user)) {
            data["user"] = [];
            for (let item of this.user)
                data["user"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAgent extends IModelBase {
    name?: string | undefined;
    user?: User[] | undefined;
    machines?: Machine[] | undefined;
}

export class Machine extends ModelBase implements IMachine {
    serialNumber!: string;
    deviceId!: string;
    linkSparePartManual?: string | undefined;
    linkUserManual?: string | undefined;
    linkVideo?: string | undefined;
    linkSupport?: string | undefined;
    linkConsumables?: string | undefined;
    linkSpareParts?: string | undefined;
    activated!: boolean;
    machineTypeId!: number;
    machineType?: MachineType | undefined;
    organizationId?: number | undefined;
    organization?: Organization | undefined;
    agentId?: number | undefined;
    agent?: Agent | undefined;
    machineStateId!: number;
    machineState?: MachineState2 | undefined;
    expiryDate!: Date;
    latestCleaning?: MachineLatestCleaning | undefined;
    latestStatistics?: MachineLatestStatistics | undefined;
    latestTankStatus?: MachineLatestTankStatus | undefined;
    users?: User[] | undefined;
    machineAlarms?: MachineAlarm[] | undefined;
    machineNickNames?: MachineNickName[] | undefined;

    constructor(data?: IMachine) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.deviceId = _data["deviceId"];
            this.linkSparePartManual = _data["linkSparePartManual"];
            this.linkUserManual = _data["linkUserManual"];
            this.linkVideo = _data["linkVideo"];
            this.linkSupport = _data["linkSupport"];
            this.linkConsumables = _data["linkConsumables"];
            this.linkSpareParts = _data["linkSpareParts"];
            this.activated = _data["activated"];
            this.machineTypeId = _data["machineTypeId"];
            this.machineType = _data["machineType"] ? MachineType.fromJS(_data["machineType"]) : undefined as any;
            this.organizationId = _data["organizationId"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : undefined as any;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            this.machineStateId = _data["machineStateId"];
            this.machineState = _data["machineState"] ? MachineState2.fromJS(_data["machineState"]) : undefined as any;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : undefined as any;
            this.latestCleaning = _data["latestCleaning"] ? MachineLatestCleaning.fromJS(_data["latestCleaning"]) : undefined as any;
            this.latestStatistics = _data["latestStatistics"] ? MachineLatestStatistics.fromJS(_data["latestStatistics"]) : undefined as any;
            this.latestTankStatus = _data["latestTankStatus"] ? MachineLatestTankStatus.fromJS(_data["latestTankStatus"]) : undefined as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["machineAlarms"])) {
                this.machineAlarms = [] as any;
                for (let item of _data["machineAlarms"])
                    this.machineAlarms!.push(MachineAlarm.fromJS(item));
            }
            if (Array.isArray(_data["machineNickNames"])) {
                this.machineNickNames = [] as any;
                for (let item of _data["machineNickNames"])
                    this.machineNickNames!.push(MachineNickName.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Machine {
        data = typeof data === 'object' ? data : {};
        let result = new Machine();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["deviceId"] = this.deviceId;
        data["linkSparePartManual"] = this.linkSparePartManual;
        data["linkUserManual"] = this.linkUserManual;
        data["linkVideo"] = this.linkVideo;
        data["linkSupport"] = this.linkSupport;
        data["linkConsumables"] = this.linkConsumables;
        data["linkSpareParts"] = this.linkSpareParts;
        data["activated"] = this.activated;
        data["machineTypeId"] = this.machineTypeId;
        data["machineType"] = this.machineType ? this.machineType.toJSON() : undefined as any;
        data["organizationId"] = this.organizationId;
        data["organization"] = this.organization ? this.organization.toJSON() : undefined as any;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["machineStateId"] = this.machineStateId;
        data["machineState"] = this.machineState ? this.machineState.toJSON() : undefined as any;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["latestCleaning"] = this.latestCleaning ? this.latestCleaning.toJSON() : undefined as any;
        data["latestStatistics"] = this.latestStatistics ? this.latestStatistics.toJSON() : undefined as any;
        data["latestTankStatus"] = this.latestTankStatus ? this.latestTankStatus.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.machineAlarms)) {
            data["machineAlarms"] = [];
            for (let item of this.machineAlarms)
                data["machineAlarms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.machineNickNames)) {
            data["machineNickNames"] = [];
            for (let item of this.machineNickNames)
                data["machineNickNames"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMachine extends IModelBase {
    serialNumber: string;
    deviceId: string;
    linkSparePartManual?: string | undefined;
    linkUserManual?: string | undefined;
    linkVideo?: string | undefined;
    linkSupport?: string | undefined;
    linkConsumables?: string | undefined;
    linkSpareParts?: string | undefined;
    activated: boolean;
    machineTypeId: number;
    machineType?: MachineType | undefined;
    organizationId?: number | undefined;
    organization?: Organization | undefined;
    agentId?: number | undefined;
    agent?: Agent | undefined;
    machineStateId: number;
    machineState?: MachineState2 | undefined;
    expiryDate: Date;
    latestCleaning?: MachineLatestCleaning | undefined;
    latestStatistics?: MachineLatestStatistics | undefined;
    latestTankStatus?: MachineLatestTankStatus | undefined;
    users?: User[] | undefined;
    machineAlarms?: MachineAlarm[] | undefined;
    machineNickNames?: MachineNickName[] | undefined;
}

export class MachineType extends ModelBase implements IMachineType {
    name?: string | undefined;
    imageName?: string | undefined;
    machines?: Machine[] | undefined;
    machineGroupId!: number;
    machineGroup?: MachineGroup | undefined;

    constructor(data?: IMachineType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.imageName = _data["imageName"];
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(Machine.fromJS(item));
            }
            this.machineGroupId = _data["machineGroupId"];
            this.machineGroup = _data["machineGroup"] ? MachineGroup.fromJS(_data["machineGroup"]) : undefined as any;
        }
    }

    static override fromJS(data: any): MachineType {
        data = typeof data === 'object' ? data : {};
        let result = new MachineType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["imageName"] = this.imageName;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item ? item.toJSON() : undefined as any);
        }
        data["machineGroupId"] = this.machineGroupId;
        data["machineGroup"] = this.machineGroup ? this.machineGroup.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineType extends IModelBase {
    name?: string | undefined;
    imageName?: string | undefined;
    machines?: Machine[] | undefined;
    machineGroupId: number;
    machineGroup?: MachineGroup | undefined;
}

export class MachineGroup extends ModelBase implements IMachineGroup {
    machineGroupType!: MachineGroupType;
    machineTypes?: MachineType[] | undefined;

    constructor(data?: IMachineGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.machineGroupType = _data["machineGroupType"];
            if (Array.isArray(_data["machineTypes"])) {
                this.machineTypes = [] as any;
                for (let item of _data["machineTypes"])
                    this.machineTypes!.push(MachineType.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MachineGroup {
        data = typeof data === 'object' ? data : {};
        let result = new MachineGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineGroupType"] = this.machineGroupType;
        if (Array.isArray(this.machineTypes)) {
            data["machineTypes"] = [];
            for (let item of this.machineTypes)
                data["machineTypes"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMachineGroup extends IModelBase {
    machineGroupType: MachineGroupType;
    machineTypes?: MachineType[] | undefined;
}

export class Organization extends ModelBase implements IOrganization {
    name?: string | undefined;
    description?: string | undefined;
    machines?: Machine[] | undefined;

    constructor(data?: IOrganization) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(Machine.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrganization extends IModelBase {
    name?: string | undefined;
    description?: string | undefined;
    machines?: Machine[] | undefined;
}

export class MachineState2 extends ModelBase implements IMachineState2 {
    machineId!: number;
    machine?: Machine | undefined;
    machineStatus?: MachineStatus | undefined;
    connectionStatus!: ConnectionStatus;
    latestConnectionStateChange?: Date | undefined;
    washCompleteAt?: Date | undefined;

    constructor(data?: IMachineState2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.machineId = _data["machineId"];
            this.machine = _data["machine"] ? Machine.fromJS(_data["machine"]) : undefined as any;
            this.machineStatus = _data["machineStatus"];
            this.connectionStatus = _data["connectionStatus"];
            this.latestConnectionStateChange = _data["latestConnectionStateChange"] ? new Date(_data["latestConnectionStateChange"].toString()) : undefined as any;
            this.washCompleteAt = _data["washCompleteAt"] ? new Date(_data["washCompleteAt"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): MachineState2 {
        data = typeof data === 'object' ? data : {};
        let result = new MachineState2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineId"] = this.machineId;
        data["machine"] = this.machine ? this.machine.toJSON() : undefined as any;
        data["machineStatus"] = this.machineStatus;
        data["connectionStatus"] = this.connectionStatus;
        data["latestConnectionStateChange"] = this.latestConnectionStateChange ? this.latestConnectionStateChange.toISOString() : undefined as any;
        data["washCompleteAt"] = this.washCompleteAt ? this.washCompleteAt.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineState2 extends IModelBase {
    machineId: number;
    machine?: Machine | undefined;
    machineStatus?: MachineStatus | undefined;
    connectionStatus: ConnectionStatus;
    latestConnectionStateChange?: Date | undefined;
    washCompleteAt?: Date | undefined;
}

export class MachineLatestCleaning extends ModelBase implements IMachineLatestCleaning {
    machineDbId!: number;
    deviceId!: string;
    machine?: Machine | undefined;
    date?: string | undefined;
    time?: string | undefined;
    sequence?: number | undefined;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;
    recipe?: string | undefined;
    washTime?: number | undefined;
    tank?: number | undefined;
    temp?: number | undefined;
    rinse?: number | undefined;
    dry?: number | undefined;
    washSpeed?: number | undefined;
    rollId?: string | undefined;
    intensity?: string | undefined;
    color?: string | undefined;
    passes?: number | undefined;

    constructor(data?: IMachineLatestCleaning) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.machineDbId = _data["machineDbId"];
            this.deviceId = _data["deviceId"];
            this.machine = _data["machine"] ? Machine.fromJS(_data["machine"]) : undefined as any;
            this.date = _data["date"];
            this.time = _data["time"];
            this.sequence = _data["sequence"];
            this.employeeId = _data["employeeId"];
            this.placeHolder = _data["placeHolder"];
            this.recipe = _data["recipe"];
            this.washTime = _data["washTime"];
            this.tank = _data["tank"];
            this.temp = _data["temp"];
            this.rinse = _data["rinse"];
            this.dry = _data["dry"];
            this.washSpeed = _data["washSpeed"];
            this.rollId = _data["rollId"];
            this.intensity = _data["intensity"];
            this.color = _data["color"];
            this.passes = _data["passes"];
        }
    }

    static override fromJS(data: any): MachineLatestCleaning {
        data = typeof data === 'object' ? data : {};
        let result = new MachineLatestCleaning();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineDbId"] = this.machineDbId;
        data["deviceId"] = this.deviceId;
        data["machine"] = this.machine ? this.machine.toJSON() : undefined as any;
        data["date"] = this.date;
        data["time"] = this.time;
        data["sequence"] = this.sequence;
        data["employeeId"] = this.employeeId;
        data["placeHolder"] = this.placeHolder;
        data["recipe"] = this.recipe;
        data["washTime"] = this.washTime;
        data["tank"] = this.tank;
        data["temp"] = this.temp;
        data["rinse"] = this.rinse;
        data["dry"] = this.dry;
        data["washSpeed"] = this.washSpeed;
        data["rollId"] = this.rollId;
        data["intensity"] = this.intensity;
        data["color"] = this.color;
        data["passes"] = this.passes;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineLatestCleaning extends IModelBase {
    machineDbId: number;
    deviceId: string;
    machine?: Machine | undefined;
    date?: string | undefined;
    time?: string | undefined;
    sequence?: number | undefined;
    employeeId?: string | undefined;
    placeHolder?: string | undefined;
    recipe?: string | undefined;
    washTime?: number | undefined;
    tank?: number | undefined;
    temp?: number | undefined;
    rinse?: number | undefined;
    dry?: number | undefined;
    washSpeed?: number | undefined;
    rollId?: string | undefined;
    intensity?: string | undefined;
    color?: string | undefined;
    passes?: number | undefined;
}

export class MachineLatestStatistics extends ModelBase implements IMachineLatestStatistics {
    machineDbId!: number;
    deviceId!: string;
    machine?: Machine | undefined;
    totalWashHours?: number | undefined;
    washHoursSinceService?: number | undefined;
    washesLeftBeforeService?: number | undefined;
    washesLeftBeforeFilterChange?: number | undefined;
    totalWashes?: number | undefined;
    washesSinceService?: number | undefined;
    totalRinses?: number | undefined;
    rinsesSinceService?: number | undefined;
    totalRinseHours?: number | undefined;
    rinseHoursSinceService?: number | undefined;
    totalAniloxes?: number | undefined;
    aniloxesSinceService?: number | undefined;
    totalLaserHours?: number | undefined;
    laserHoursSinceService?: number | undefined;
    totalVacuumHours?: number | undefined;
    vacuumHoursSinceFilterChange?: number | undefined;
    vacuumHoursUntilNextFilter?: number | undefined;
    washesLeftBeforeLiquidChange?: number | undefined;

    constructor(data?: IMachineLatestStatistics) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.machineDbId = _data["machineDbId"];
            this.deviceId = _data["deviceId"];
            this.machine = _data["machine"] ? Machine.fromJS(_data["machine"]) : undefined as any;
            this.totalWashHours = _data["totalWashHours"];
            this.washHoursSinceService = _data["washHoursSinceService"];
            this.washesLeftBeforeService = _data["washesLeftBeforeService"];
            this.washesLeftBeforeFilterChange = _data["washesLeftBeforeFilterChange"];
            this.totalWashes = _data["totalWashes"];
            this.washesSinceService = _data["washesSinceService"];
            this.totalRinses = _data["totalRinses"];
            this.rinsesSinceService = _data["rinsesSinceService"];
            this.totalRinseHours = _data["totalRinseHours"];
            this.rinseHoursSinceService = _data["rinseHoursSinceService"];
            this.totalAniloxes = _data["totalAniloxes"];
            this.aniloxesSinceService = _data["aniloxesSinceService"];
            this.totalLaserHours = _data["totalLaserHours"];
            this.laserHoursSinceService = _data["laserHoursSinceService"];
            this.totalVacuumHours = _data["totalVacuumHours"];
            this.vacuumHoursSinceFilterChange = _data["vacuumHoursSinceFilterChange"];
            this.vacuumHoursUntilNextFilter = _data["vacuumHoursUntilNextFilter"];
            this.washesLeftBeforeLiquidChange = _data["washesLeftBeforeLiquidChange"];
        }
    }

    static override fromJS(data: any): MachineLatestStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new MachineLatestStatistics();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineDbId"] = this.machineDbId;
        data["deviceId"] = this.deviceId;
        data["machine"] = this.machine ? this.machine.toJSON() : undefined as any;
        data["totalWashHours"] = this.totalWashHours;
        data["washHoursSinceService"] = this.washHoursSinceService;
        data["washesLeftBeforeService"] = this.washesLeftBeforeService;
        data["washesLeftBeforeFilterChange"] = this.washesLeftBeforeFilterChange;
        data["totalWashes"] = this.totalWashes;
        data["washesSinceService"] = this.washesSinceService;
        data["totalRinses"] = this.totalRinses;
        data["rinsesSinceService"] = this.rinsesSinceService;
        data["totalRinseHours"] = this.totalRinseHours;
        data["rinseHoursSinceService"] = this.rinseHoursSinceService;
        data["totalAniloxes"] = this.totalAniloxes;
        data["aniloxesSinceService"] = this.aniloxesSinceService;
        data["totalLaserHours"] = this.totalLaserHours;
        data["laserHoursSinceService"] = this.laserHoursSinceService;
        data["totalVacuumHours"] = this.totalVacuumHours;
        data["vacuumHoursSinceFilterChange"] = this.vacuumHoursSinceFilterChange;
        data["vacuumHoursUntilNextFilter"] = this.vacuumHoursUntilNextFilter;
        data["washesLeftBeforeLiquidChange"] = this.washesLeftBeforeLiquidChange;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineLatestStatistics extends IModelBase {
    machineDbId: number;
    deviceId: string;
    machine?: Machine | undefined;
    totalWashHours?: number | undefined;
    washHoursSinceService?: number | undefined;
    washesLeftBeforeService?: number | undefined;
    washesLeftBeforeFilterChange?: number | undefined;
    totalWashes?: number | undefined;
    washesSinceService?: number | undefined;
    totalRinses?: number | undefined;
    rinsesSinceService?: number | undefined;
    totalRinseHours?: number | undefined;
    rinseHoursSinceService?: number | undefined;
    totalAniloxes?: number | undefined;
    aniloxesSinceService?: number | undefined;
    totalLaserHours?: number | undefined;
    laserHoursSinceService?: number | undefined;
    totalVacuumHours?: number | undefined;
    vacuumHoursSinceFilterChange?: number | undefined;
    vacuumHoursUntilNextFilter?: number | undefined;
    washesLeftBeforeLiquidChange?: number | undefined;
}

export class MachineLatestTankStatus extends ModelBase implements IMachineLatestTankStatus {
    machineDbId!: number;
    deviceId!: string;
    machine?: Machine | undefined;
    numberOfTanks?: number | undefined;
    temperatureTank1?: number | undefined;
    tempStatusTank1?: TankTempStatus | undefined;
    levelTank1?: TankLevel | undefined;
    temperatureTank2?: number | undefined;
    tempStatusTank2?: TankTempStatus | undefined;
    levelTank2?: TankLevel | undefined;

    constructor(data?: IMachineLatestTankStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.machineDbId = _data["machineDbId"];
            this.deviceId = _data["deviceId"];
            this.machine = _data["machine"] ? Machine.fromJS(_data["machine"]) : undefined as any;
            this.numberOfTanks = _data["numberOfTanks"];
            this.temperatureTank1 = _data["temperatureTank1"];
            this.tempStatusTank1 = _data["tempStatusTank1"];
            this.levelTank1 = _data["levelTank1"];
            this.temperatureTank2 = _data["temperatureTank2"];
            this.tempStatusTank2 = _data["tempStatusTank2"];
            this.levelTank2 = _data["levelTank2"];
        }
    }

    static override fromJS(data: any): MachineLatestTankStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MachineLatestTankStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineDbId"] = this.machineDbId;
        data["deviceId"] = this.deviceId;
        data["machine"] = this.machine ? this.machine.toJSON() : undefined as any;
        data["numberOfTanks"] = this.numberOfTanks;
        data["temperatureTank1"] = this.temperatureTank1;
        data["tempStatusTank1"] = this.tempStatusTank1;
        data["levelTank1"] = this.levelTank1;
        data["temperatureTank2"] = this.temperatureTank2;
        data["tempStatusTank2"] = this.tempStatusTank2;
        data["levelTank2"] = this.levelTank2;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineLatestTankStatus extends IModelBase {
    machineDbId: number;
    deviceId: string;
    machine?: Machine | undefined;
    numberOfTanks?: number | undefined;
    temperatureTank1?: number | undefined;
    tempStatusTank1?: TankTempStatus | undefined;
    levelTank1?: TankLevel | undefined;
    temperatureTank2?: number | undefined;
    tempStatusTank2?: TankTempStatus | undefined;
    levelTank2?: TankLevel | undefined;
}

export class MachineAlarm extends ModelBase implements IMachineAlarm {
    alarmType!: AlarmType;
    alarmIndex!: number;
    errorDescription?: string | undefined;
    active!: boolean;
    machineId!: number;
    machine?: Machine | undefined;

    constructor(data?: IMachineAlarm) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.alarmType = _data["alarmType"];
            this.alarmIndex = _data["alarmIndex"];
            this.errorDescription = _data["errorDescription"];
            this.active = _data["active"];
            this.machineId = _data["machineId"];
            this.machine = _data["machine"] ? Machine.fromJS(_data["machine"]) : undefined as any;
        }
    }

    static override fromJS(data: any): MachineAlarm {
        data = typeof data === 'object' ? data : {};
        let result = new MachineAlarm();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmType"] = this.alarmType;
        data["alarmIndex"] = this.alarmIndex;
        data["errorDescription"] = this.errorDescription;
        data["active"] = this.active;
        data["machineId"] = this.machineId;
        data["machine"] = this.machine ? this.machine.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineAlarm extends IModelBase {
    alarmType: AlarmType;
    alarmIndex: number;
    errorDescription?: string | undefined;
    active: boolean;
    machineId: number;
    machine?: Machine | undefined;
}

export class MachineNickName extends ModelBase implements IMachineNickName {
    nickName?: string | undefined;
    machineId!: number;
    machine?: Machine | undefined;
    userId!: number;
    user?: User | undefined;

    constructor(data?: IMachineNickName) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nickName = _data["nickName"];
            this.machineId = _data["machineId"];
            this.machine = _data["machine"] ? Machine.fromJS(_data["machine"]) : undefined as any;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static override fromJS(data: any): MachineNickName {
        data = typeof data === 'object' ? data : {};
        let result = new MachineNickName();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nickName"] = this.nickName;
        data["machineId"] = this.machineId;
        data["machine"] = this.machine ? this.machine.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineNickName extends IModelBase {
    nickName?: string | undefined;
    machineId: number;
    machine?: Machine | undefined;
    userId: number;
    user?: User | undefined;
}

export class Device extends ModelBase implements IDevice {
    userId!: number;
    user?: User | undefined;
    deviceToken?: string | undefined;
    deviceId?: string | undefined;

    constructor(data?: IDevice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.deviceToken = _data["deviceToken"];
            this.deviceId = _data["deviceId"];
        }
    }

    static override fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["deviceToken"] = this.deviceToken;
        data["deviceId"] = this.deviceId;
        super.toJSON(data);
        return data;
    }
}

export interface IDevice extends IModelBase {
    userId: number;
    user?: User | undefined;
    deviceToken?: string | undefined;
    deviceId?: string | undefined;
}

export class UserSetting extends ModelBase implements IUserSetting {
    language!: Language;
    workDays?: DayOfWeek[] | undefined;
    timezoneId?: string | undefined;
    workingHoursStart!: number;
    workingHoursEnd!: number;
    userId!: number;
    user?: User | undefined;

    constructor(data?: IUserSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.language = _data["language"];
            if (Array.isArray(_data["workDays"])) {
                this.workDays = [] as any;
                for (let item of _data["workDays"])
                    this.workDays!.push(item);
            }
            this.timezoneId = _data["timezoneId"];
            this.workingHoursStart = _data["workingHoursStart"];
            this.workingHoursEnd = _data["workingHoursEnd"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static override fromJS(data: any): UserSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        if (Array.isArray(this.workDays)) {
            data["workDays"] = [];
            for (let item of this.workDays)
                data["workDays"].push(item);
        }
        data["timezoneId"] = this.timezoneId;
        data["workingHoursStart"] = this.workingHoursStart;
        data["workingHoursEnd"] = this.workingHoursEnd;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUserSetting extends IModelBase {
    language: Language;
    workDays?: DayOfWeek[] | undefined;
    timezoneId?: string | undefined;
    workingHoursStart: number;
    workingHoursEnd: number;
    userId: number;
    user?: User | undefined;
}

export class NotificationSubscriptionDTO implements INotificationSubscriptionDTO {
    notifyPush!: boolean;
    userId!: number;
    machineId!: number;

    constructor(data?: INotificationSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notifyPush = _data["notifyPush"];
            this.userId = _data["userId"];
            this.machineId = _data["machineId"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyPush"] = this.notifyPush;
        data["userId"] = this.userId;
        data["machineId"] = this.machineId;
        return data;
    }
}

export interface INotificationSubscriptionDTO {
    notifyPush: boolean;
    userId: number;
    machineId: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export {};